import React from 'react';
import PropTypes from 'prop-types';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
// actions
import {uploadAdd, uploadXPStart} from '~/actions/AnalyticsActions';
import {uploadFile} from '~/actions/UploadActions';
// selectors
import {getRecentUploadIcons} from '~/selectors/CanvasSelectors';
// vendor
import {metrics} from '~/vendor/metrics';

import './index.scss';

const propTypes = {
  children: PropTypes.node,
  mobileUpload: PropTypes.bool
};

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
const UploadButton = ({children, mobileUpload}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const recentUploads = useSelector(getRecentUploadIcons);

  /** @param {React.ChangeEvent<HTMLInputElement>} ev */
  const handleUploadFile = ev => {
    metrics.pageViewTag('ndx/upload/browse');
    dispatch(
      uploadAdd({
        action: 'browse'
      })
    );
    dispatch(
      uploadFile({
        acceptedFile: ev.target.files[0],
        onUploadStarted: () => navigate('/uploadProgress'),
        uploadType: 'browse'
      })
    );
  };
  const source = mobileUpload ? 'blank canvas options' : 'menu';

  const handleMouseUp = () => {
    metrics.pageViewTag('ndx/upload');
    dispatch(
      uploadXPStart({
        source: source
      })
    );
  };

  const navigateToRecentUploadSandwich = () => {
    dispatch(
      uploadXPStart({
        source: source
      })
    );
    return navigate('/uploadTools/preview');
  };

  if (recentUploads?.length) {
    return (
      <div className="ndx-MenuButton ndx-AddDesignToolbar-item ndx-UploadButton">
        {children}
        <div
          data-testid={'ndx-UploadButton-fake-input'}
          className="ndx-UploadButton-input"
          onClick={navigateToRecentUploadSandwich}
        />
      </div>
    );
  }

  return (
    <div className="ndx-MenuButton ndx-AddDesignToolbar-item ndx-UploadButton">
      {children}
      <input
        data-testid={'ndx-UploadButton-input'}
        className="ndx-UploadButton-input"
        type="file"
        onChange={handleUploadFile}
        onMouseUp={handleMouseUp}
      />
    </div>
  );
};

UploadButton.propTypes = propTypes;

export default UploadButton;
